module.exports = __webpack_public_path__ + "static/media/dashboard.6f2f1188.svg";